/* ==========================================================================
   Kopstorm CRO Suite - Wave 5 behaviour
   W58 chip popovers · W61 description clamp · preview toolbar

   W55, W56, W57, W59 and W60 need no JavaScript at all:
     W55 reveals buttons the theme already renders and already wires
     W56 and W57 are CSS order on classes the inline classifier in
         main-product.liquid assigns before first paint
     W59 reuses the Wave 3 quiz trigger, [data-kop3-quiz-open]
     W60 swaps between two server rendered price chips
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var W5 = window.KopstormW5 || {};
  var copy = W5.copy || {};
  var conf = W5.settings || {};

  function t(key, fallback) {
    var value = copy[key];
    return typeof value === 'string' && value !== '' ? value : fallback;
  }
  function has(flag) { return root.classList.contains('kop-' + flag); }
  function on(flag) { return has(flag) || has('w5editor') || has('w5preview'); }

  /* ------------------------------------------------------------------
     W58 · chips reuse the Wave 4 popover when it is on the page
     ------------------------------------------------------------------ */
  function chipInfo(kind) {
    var w4 = (window.KopstormW4 || {}).copy || {};
    /* No difficulty branch on purpose: the level chip was removed after K_08,
       where a visible skill badge cost 17 percent of conversion. */
    if (kind === 'tools') {
      return { title: t('chip_no_tools', ''), html: '<p>' + t('chip_no_tools_text', '').replace(/[<>]/g, '') + '</p>' };
    }
    if (kind === 'time') {
      /* Client feedback 5 Aug 2026: this chip shows the build time, so its
         popover explains the build time and how it relates to the piece
         count, instead of reusing the Wave 4 piece count popover. */
      return { title: t('chip_time_title', w4.pieces_title || ''), html: '<p>' + t('chip_time_text', w4.pieces_text || '').replace(/[<>]/g, '') + '</p>' };
    }
    return { title: w4.gift_title || '', html: '<p>' + (w4.gift_text || '').replace(/[<>]/g, '') + '</p>' };
  }

  doc.addEventListener('click', function (event) {
    if (!on('w58')) return;
    var chip = event.target.closest('[data-kop5-chip]');
    if (!chip) return;
    var pop = window.KopstormPop;
    if (!pop || typeof pop.open !== 'function') return;
    event.preventDefault();
    var info = chipInfo(chip.getAttribute('data-kop5-chip'));
    if (!info.title && !info.html) return;
    doc.querySelectorAll('[data-kop5-chip]').forEach(function (other) {
      if (other !== chip) other.setAttribute('aria-expanded', 'false');
    });
    var wasOpen = chip.getAttribute('aria-expanded') === 'true';
    chip.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
    pop.open(chip, info.title, info.html);
  });

  /* ------------------------------------------------------------------
     W55 · make the revealed arrows actually move the gallery
     ------------------------------------------------------------------
     Two theme problems, both confirmed in theme.js. First, SliderElement
     scrolls by perPage * itemOffset, and on the product gallery the
     slides are full width with a small gap, so perPage computes 0 and
     the theme's own scroll distance is zero. Second, letting the
     theme's click handler run alongside ours creates a race: its
     zero-distance scrollTo fires right after ours and smooth-scrolls
     the gallery back to where it started, cancelling the move. So this
     handler takes single ownership of the click: it stops the event at
     the capture phase, before the theme's button handler can dispatch
     its slider event, and performs the one-slide scroll itself. The
     theme's disabled and hidden status updates keep working, since they
     react to the scroll position, not to who scrolled.
     ------------------------------------------------------------------ */
  doc.addEventListener('click', function (event) {
    if (!on('w55')) return;
    if (!event.target || !event.target.closest) return;
    var button = event.target.closest('.product__media-container .indicators .button');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var slider = null;
    var controls = button.getAttribute('aria-controls');
    if (controls) slider = doc.getElementById(controls);
    if (!slider) {
      var container = button.closest('.product__media-container');
      slider = container ? container.querySelector('slider-element') : null;
    }
    if (!slider || typeof slider.scrollTo !== 'function') return;
    var sel = slider.getAttribute('selector');
    var items = sel ? slider.querySelectorAll(sel) : slider.children;
    items = Array.prototype.filter.call(items, function (el) { return el.clientWidth > 0; });
    var offset = items.length > 1 ? (items[1].offsetLeft - items[0].offsetLeft) : slider.clientWidth;
    if (!offset || offset <= 0) offset = slider.clientWidth;
    var dir = button.getAttribute('is') === 'previous-button' ? -1 : 1;
    var rtl = !!(window.theme && theme.config && theme.config.rtl);
    var max = Math.max(0, slider.scrollWidth - slider.clientWidth);
    var target = slider.scrollLeft + dir * offset * (rtl ? -1 : 1);
    if (target < 0) target = 0;
    if (target > max) target = max;
    slider.scrollTo({ left: target, behavior: 'smooth' });
  }, true);

  /* ------------------------------------------------------------------
     W61 · mobile description clamp
     ------------------------------------------------------------------ */
  function initClamp() {
    var info = doc.querySelector('product-info');
    if (!info) return;
    var target = info.querySelector('.product__text .rte, .product__text.rte');
    if (!target || target.dataset.kop5Clamp) return;
    target.dataset.kop5Clamp = '1';
    /* The paragraph sits inside .product__text-inner, which is a flex row, so
       inserting the toggle next to the paragraph put it BESIDE the text. It
       has to go after the outermost .product__text block instead. */
    var host = target.closest('.product__text') || target;

    var lines = parseInt(conf.w61_lines, 10);
    if (!lines || lines < 2) lines = 4;
    target.style.setProperty('--kop5-lines', String(lines));
    target.classList.add('kop5-clamped');

    var toggle = doc.createElement('button');
    toggle.type = 'button';
    toggle.className = 'kop5-clamp-toggle';
    toggle.textContent = t('read_more', 'Read more');
    host.insertAdjacentElement('afterend', toggle);

    function sync() {
      var clamped = target.classList.contains('kop5-clamped');
      var overflowing = target.scrollHeight > target.clientHeight + 2;
      toggle.classList.toggle('kop5-clamp-toggle--show', overflowing || !clamped);
    }
    toggle.addEventListener('click', function () {
      var clamped = target.classList.toggle('kop5-clamped');
      toggle.textContent = clamped ? t('read_more', 'Read more') : t('read_less', 'Read less');
      sync();
    });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ------------------------------------------------------------------
     W55 · label the theme's own arrows for screen readers
     The buttons exist and work; they only ever lacked a visible state.
     ------------------------------------------------------------------ */
  function labelArrows() {
    doc.querySelectorAll('.product__media-container .indicators [is="previous-button"]').forEach(function (b) {
      if (copy.prev) b.setAttribute('aria-label', copy.prev);
    });
    doc.querySelectorAll('.product__media-container .indicators [is="next-button"]').forEach(function (b) {
      if (copy.next) b.setAttribute('aria-label', copy.next);
    });
  }

  /* ------------------------------------------------------------------
     W56 / W57 · keep the mobile layout in step

     The move itself happens in the inline engine in main-product.liquid,
     before first paint. This only re-runs it when a flag flips from the
     toolbar or a ?kop= parameter, and when the viewport crosses the
     breakpoint, which is what the theme editor does when you switch to the
     phone view.
     ------------------------------------------------------------------ */
  function relayout() {
    var api = window.KopstormW5Layout;
    if (api && typeof api.apply === 'function') api.apply();
  }
  var mq = window.matchMedia('(max-width: 989px)');
  if (mq.addEventListener) mq.addEventListener('change', relayout);
  else if (mq.addListener) mq.addListener(relayout);
  window.addEventListener('resize', function () {
    window.clearTimeout(relayout._t);
    relayout._t = window.setTimeout(relayout, 150);
  });

  /* ------------------------------------------------------------------
     W64 · wrap the checkmark row so the fade has something to sit on,
     and drop the fade once the strip is scrolled to the end
     ------------------------------------------------------------------ */
  function initUspStrip() {
    var list = doc.querySelector('.pdp-usp-check--global .pdp-usp-check__list');
    if (!list) return;
    var wrap = list.parentNode;
    if (!wrap || !wrap.classList.contains('kop5-usp-wrap')) {
      wrap = doc.createElement('div');
      wrap.className = 'kop5-usp-wrap';
      list.parentNode.insertBefore(wrap, list);
      wrap.appendChild(list);
    }
    if (list.dataset.kop5Usp) return;
    list.dataset.kop5Usp = '1';
    function sync() {
      var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      var noOverflow = list.scrollWidth <= list.clientWidth + 2;
      if (atEnd || noOverflow) wrap.setAttribute('data-kop5-usp-end', '');
      else wrap.removeAttribute('data-kop5-usp-end');
    }
    list.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function refresh() {
    relayout();
    if (on('w64')) initUspStrip();
    if (on('w61')) initClamp();
    if (on('w55')) labelArrows();
  }

  doc.addEventListener('kopstorm:flag', refresh);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', refresh);
  else refresh();

  /* ------------------------------------------------------------------
     Preview toolbar (kop_w5_preview only)
     ------------------------------------------------------------------ */
  var toolbar = doc.querySelector('[data-kop5-toolbar]');
  if (toolbar) {
    var registry = [
      { id: 'w55', label: 'W55 Gallery arrows' },
      { id: 'w56', label: 'W56 Mobile: title above gallery' },
      { id: 'w57', label: 'W57 Mobile: buy under Kaching' },
      { id: 'w58', label: 'W58 Answer chips under price' },
      { id: 'w59', label: 'W59 Quiz entry in buy area' },
      { id: 'w60', label: 'W60 Savings without discount wording' },
      { id: 'w61', label: 'W61 Mobile description clamp' },
      { id: 'w62', label: 'W62 Savings: money saved' },
      { id: 'w62b', label: 'W62b Savings: value added' },
      { id: 'w63', label: 'W63 Klarna under the price' },
      { id: 'w64', label: 'W64 Checkmarks as a swipe strip' },
      { id: 'w65', label: 'W65 Larger type on the PDP' },
      { id: 'w66', label: 'W66 Standardised gift label' }
    ];
    var handle = toolbar.querySelector('[data-kop5-toolbar-handle]');
    var panel = toolbar.querySelector('[data-kop5-toolbar-panel]');
    var rowsHost = toolbar.querySelector('[data-kop5-toolbar-rows]');
    var countMark = toolbar.querySelector('[data-kop5-toolbar-count]');
    var api = window.KopstormCRO || null;

    function setFlag(id, active) {
      if (api && api.enable && api.disable) {
        if (active) api.enable(id); else api.disable(id);
      } else {
        root.classList.toggle('kop-' + id, active);
      }
      /* The two savings arms share one slot and can never both be on */
      if (id === 'w62' && active) setFlag('w62b', false);
      if (id === 'w62b' && active) setFlag('w62', false);
    }
    function renderRows() {
      rowsHost.innerHTML = '';
      var count = 0;
      registry.forEach(function (test) {
        var active = has(test.id);
        if (active) count += 1;
        var row = doc.createElement('label');
        row.className = 'kop5-toolbar__row';
        var box = doc.createElement('input');
        box.type = 'checkbox';
        box.checked = active;
        box.addEventListener('change', function () {
          setFlag(test.id, box.checked);
          renderRows();
          refresh();
        });
        var text = doc.createElement('span');
        text.textContent = test.label;
        row.appendChild(box);
        row.appendChild(text);
        rowsHost.appendChild(row);
      });
      countMark.textContent = String(count);
    }
    handle.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden');
      if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
      handle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) renderRows();
    });
    toolbar.querySelector('[data-kop5-toolbar-all]').addEventListener('click', function () {
      registry.forEach(function (test) { if (test.id !== 'w62b') setFlag(test.id, true); });
      renderRows();
      refresh();
    });
    toolbar.querySelector('[data-kop5-toolbar-none]').addEventListener('click', function () {
      registry.forEach(function (test) { setFlag(test.id, false); });
      renderRows();
      refresh();
    });
    doc.addEventListener('kopstorm:flag', function () {
      if (!panel.hasAttribute('hidden')) renderRows();
    });
    renderRows();
  }
})();
